import { render, staticRenderFns } from "./html.vue?vue&type=template&id=ecc5fbce&scoped=true"
import script from "./html.vue?vue&type=script&lang=ts"
export * from "./html.vue?vue&type=script&lang=ts"
import style0 from "./html.vue?vue&type=style&index=0&id=ecc5fbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc5fbce",
  null
  
)

export default component.exports